import { createFileRoute } from '@tanstack/react-router';
import { MenuPickerScreen } from '@/features/allergens/MenuPickerScreen';

export const Route = createFileRoute('/_app/allergens/menu')({
  component: MenuPickerScreen,
});
